import { createI18n } from 'vue-i18n';
import isoCountries from 'i18n-iso-countries';

// Register locale data for countries
import enCountryLocale from 'i18n-iso-countries/langs/en.json';
import deCountryLocale from 'i18n-iso-countries/langs/de.json';

// Locales
import enLocale from '../locales/en.json';
import deLocale from '../locales/de.json';

export const i18n = createI18n({
    legacy: false,
    locale: 'de',
    fallbackLocale: 'de',
    globalInjection: true,
    messages:{
        gb: enLocale,
        de: deLocale
    }
});

isoCountries.registerLocale(enCountryLocale); // Registration of English translation
isoCountries.registerLocale(deCountryLocale); // Registration of German translation

export default isoCountries;

